// Define Grid Content Action types
export enum ContextActionEnum {
  SET_FINANCIAL_FIELDS = 'SET_FINANCIAL_FIELDS',
  SET_ORDER_ID = 'SET_ORDER_ID',
}
